var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('lora-forwarder-run-status-widget',{attrs:{"widget-loading":_vm.Loading,"show-link":false,"forwarder":_vm.forwarder}}),_c('lora-hardware-widget')],1),_c('lora-forwarder-status')],1)}
var staticRenderFns = []

export { render, staticRenderFns }